import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import { nl2 } from 'util/filters';
import { withRouter } from 'react-router';

class Alert extends React.Component {
  componentDidMount() {
    this.unlisten = this.props.history.listen(() => {
      this.props.closeAlert();
    });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  render() {
    const { className, message, closeAlert, visible } = this.props;
    return (
      <div className={`${className} ${visible ? '' : 'hidden'}`}>
        <p>{nl2(message)}</p>
        <button type="button" onClick={closeAlert}>
          <i className="fa fa-times" />
        </button>
      </div>
    );
  }
}

const commonStyle = css`
  position: fixed;
  top: 10%;
  right: 0;
  left: 0;
  margin: auto;
  background-color: #f8e4e4;
  border: 1px solid #f87272;
  color: #f87272;
  border-radius: 4px;
  opacity: 1;
  visibility: visible;
  transition-property: opacity, visibility;
  transition-duration: 0.2s;
  transition-timing-function: ease;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &.hidden {
    opacity: 0;
    visibility: hidden;
  }

  p {
    margin: 0;
    white-space: pre-wrap;
  }

  button {
    background-color: transparent;
    padding: 0;
    border: 0;
    outline: none;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  width: 80vw;
  padding: 10px 20px;
  max-width: 800px;

  button {
    margin-left: 20px;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  width: 90vw;
  padding: 10px;

  button {
    margin-left: 10px;
  }
`;

export default withRouter(applyStyles(Alert)(commonStyle, pcStyle, spStyle));



// WEBPACK FOOTER //
// ./src/components/common/Alert/index.js